

























































import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { Action, namespace } from 'vuex-class';
import { ActionError as campaignStoreErr } from '@/store/campaign/types';

import { Report as terms } from '@/const/terms/mainTerms';
import { ComponentTerms } from '@/const/terms/componentTerms';
import { SetCampaign as feedbackTerms } from '@/const/terms/feedback/campaign';

import { IAPP } from '@/const/types';
import { STATUS } from '@/const/status';
import {
    CampaignDataType,
    ISearchForm,
    ICampaignData,
    CampaignResponse,
} from './types';
import { DefaultOption, TableOptionType } from '@/const/options/DefaultTableOption';

import {ORIGIN_FORMAT} from '@/utils';
import { RawLocation } from 'vue-router';
import { TableColumn } from 'element-ui/types/table-column';
import { Table } from 'element-ui';
import { SummaryMethodParams } from 'element-ui/types/table';

import DateRangePicker from '@/components/ElementComponent/Date/DateRangePicker.vue';
import Select from '@/components/ElementComponent/Select/index.vue';
import { SelectOptionType } from '@/components/ElementComponent/Select/types';
import NumberColumn from '@/components/ElementComponent/Column/NumberColumn.vue';
import DateColumn from '@/components/ElementComponent/Column/DateColumn.vue';
import StatusColumn from '@/components/ElementComponent/Column/StatusColumn.vue';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';
import ExplainColumn from '@/components/ElementComponent/Column/ExplainColumn.vue';
import NameColumn from '@/components/ElementComponent/Column/NameColumn.vue';
import NumberInput from '@/components/ElementComponent/Input/NumberInput.vue';

import { AxiosResponse, AxiosError } from 'axios';

const campaignModule = namespace('Campaign');

@Component<Campaign>({
    name: 'Campaign',
    components: {
        DateRangePicker,
        Select,
        NumberColumn,
        DateColumn,
        StatusColumn,
        SelectAllColumn,
        ExplainColumn,
        NameColumn,
        NumberInput,
    },
})
export default class Campaign extends Vue {
    private terms = terms;
    private compTerms = ComponentTerms;

    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private subLoading: number = 0;
    private isUtilsCollapsed: boolean = false;

    private dateValue: Date[] = [new Date(), new Date()];
    private filterForm: ISearchForm = { status: STATUS.ACTIVE, pageSize: 20, apps: [], query: '', page: 1, totalPages: 0, sort: '' };
    private statusOptions: { value: STATUS; label: string; }[] = [
        { value: STATUS.ALL, label: '모든 상태' },
        { value: STATUS.ACTIVE, label: '활성' },
        { value: STATUS.INACTIVE, label: '비활성' },
    ];
    private pageSizeOptions: { value: number; label: string; }[] = [
        {value: 20, label: '20개'},
        {value: 30, label: '30개'},
        {value: 50, label: '50개'},
        {value: 100, label: '100개'},
    ]
    private appOptions: SelectOptionType<IAPP>[] = [];
    private tableData: CampaignDataType = [];
    private checkedCampaign: CampaignDataType = [];
    private exportingTable = false;

    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign: any;

    get date() {
        return [
            moment(this.dateValue[0]).format('YYYYMMDDHH'),
            moment(this.dateValue[1]).format('YYYYMMDDHH'),
        ];
    }
    private handleSummary(param: SummaryMethodParams) {
        const { columns, data } = param as {columns: any[], data: CampaignDataType};
        const sums = [] as string[];
        columns.forEach((column: any, index: number) => {            
            if (column.label === this.compTerms.column.campaign.name) {
                sums[index] = '합계';
                return;
            }
            const values = data.map((item: ICampaignData | any) => Number(item[column.property]));
            let unit = '';
            if (column.label === this.compTerms.column.impression || column.label === this.compTerms.column.click)
                unit = ' 회';
            if (column.label === this.compTerms.column.ctr) 
                unit = ' %';
            if (column.label === this.compTerms.column.totalBudget ||
                column.label === this.compTerms.column.dailyBudget ||
                column.label === this.compTerms.column.spentBudget  )
                unit = ' 원';

            if (unit !== '' && !values.every((value: number) => isNaN(value))) {
                if (column.label === this.compTerms.column.ctr) {
                    const imp = data.map((item: ICampaignData) => Number(item.impression)).reduce((prev, curr) => prev + (curr > 0 ? curr : 0) , 0);
                    const click = data.map((item: ICampaignData) => Number(item.click)).reduce((prev, curr) => prev + (curr > 0 ? curr : 0) , 0);

                    sums[index] = (imp > 0) ? (ORIGIN_FORMAT.NumberFormatOrigin((click / imp) * 100 ) + unit) : (' - ' + unit);
                } else {
                    sums[index] = ORIGIN_FORMAT.NumberFormatOrigin(values.reduce((prev, curr) => prev + (curr > 0 ? curr : 0) , 0)) + unit;
                }
                return;    
            } else if (unit !== ''){
                sums[index] = '-' + unit;
                return;
            }
            sums[index] = '';
        });
        return sums;
    }

    private async setCurrentCampaignHandler(scope: any, to: RawLocation, isCtrlPressed: boolean) {
        try {
            const app = this.appOptions.find((v: SelectOptionType<IAPP>) => (v.value as IAPP).key.toString() === scope.row.appKey.toString())
            await this.setCurrentCampaign({
                id: scope.row.id,
                name: scope.row.name,
                app: app ? app.value : null,
            });
            if (isCtrlPressed) {
                const routerData = this.$router.resolve(to);
                window.open(routerData.href, '_blank');
            } else {
                this.$router.push(to);
            }
        } catch (err) {
            switch (err.type) {
                case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                    this.$notify.error(feedbackTerms.currentCampaign.error.fail);
                    break;
            }
            throw err;
        }
    }

    private appKeyMatchFormatter(row: any, column: TableColumn) {
        if (this.tableData.length === 0 && this.appOptions.length === 0) {
            return '확인 중...';
        }
        const app = this.appOptions.find((v: SelectOptionType<IAPP>) => (v.value as IAPP).key.toString() === row[column.property].toString())
        if (app && app.label) {
            return app.label;
        }
        return '알 수 없음';
    }

    private async excelDownloadHandler() {
        try {
            this.exportingTable = true;
            const response = await this.$http.adserverAPI.post('GetCampaignReport', {
                since: this.date[0],
                until: this.date[1],
                status: this.filterForm.status,
                app: this.filterForm.apps.map((app: IAPP) => app.key),
                query: this.filterForm.query,
                sort: this.filterForm.sort,
                page_no: 1,
                page_size: 10000,
            });

            const campaignList = response.data.campaigns.map((item: ICampaignData) => {
                const imp = item.impression;
                const click = item.click;
                const ctr = imp === 0 ? '-1' : (click / imp) * 100;
                return { ...item, ctr: ctr } as ICampaignData;
            });

            const table = this.$refs.table as Table;
            const columns = (table as any).columns;

            const keys: string[] = [];
            let content = "";

            columns.forEach((item: any, index: number) => {
                if (item.property) {
                    if (keys.length !== 0) content += ',';
                    content += '"' + item.label + '"';
                    keys.push(item.property);
                }
            });

            campaignList.forEach((item: ICampaignData) => {
                content += '\n';            
                keys.forEach((key: string, index: number) => {
                    if (index !== 0) content += ',';

                    content += '"';
                    const checkNum = Number.parseFloat(item[key as keyof ICampaignData] as string);

                    if (key.toLowerCase().includes('date')) {
                        if (item[key as keyof ICampaignData]) {
                            content += moment(item[key]).format('YYYY-MM-DD');
                        } else {
                            content += '계속';
                        }
                    } else if (key === 'appKey') {
                        const app = this.appOptions.find((v: SelectOptionType<IAPP>) => (v.value as IAPP).key.toString() === (item[key as keyof ICampaignData] as number).toString())
                        if (app && app.label) {
                            content += app.label;
                        }
                        else content += '알 수 없는 앱';
                    } else if ( key.toLowerCase() === 'ctr' ) {
                        if (Number.isNaN(checkNum) || checkNum === -1) {
                            content += ' - ';
                        } else {
                            content += ORIGIN_FORMAT.NumberFormatOrigin(checkNum);
                        }
                    } else if (!Number.isNaN(checkNum)) {
                        content += ORIGIN_FORMAT.NumberFormatOrigin(checkNum);
                    } else if (item[key as keyof ICampaignData]){
                        content += item[key as keyof ICampaignData];
                    }
                    content += '"';
                })
            })
            const BOM = "\uFEFF";
            content = BOM + content
            const url = window.URL.createObjectURL(new Blob([content], {type: "text/csv"}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `[${terms.campaign.title}]_${moment(this.dateValue[0]).format('YYYY-MM-DD')}_${moment(this.dateValue[1]).format('YYYY-MM-DD')}.csv`)
            link.click();
        } catch (err) {
            if (err.response && (err.response as AxiosResponse).status !== 200) {
                this.$notify.error(feedbackTerms.getResponse.error.fail);
            } else {
                this.$notify.error(err.message);
            }
            throw err;
        } finally {
            this.exportingTable = false;
        }
    }
    private refreshDate(v: Date[]) {
        if (v) {
            this.getCampaignResponseHandler();
        }
    }

    private sortChangeHandler({ column, prop, order }: { column: any, prop: string, order: string }) {
        if (prop) {
            this.filterForm.sort = (order === 'ascending' ? '' : '-') + prop;
        } else {
            this.filterForm.sort = '';
        }
        this.getCampaignResponseHandler();
    }
    private getCampaignResponseHandler() {
        this.loading = true;
        this.subLoading++;
        this.checkedCampaign = [];
        this.getCampaignResponse().then((res: any) => res.data)
            .then((data: CampaignResponse) => {
                this.tableData = data.campaigns.map((item: ICampaignData) => {
                    const imp = item.impression;
                    const click = item.click;
                    const ctr = imp === 0 ? '-1' : (click / imp) * 100;
                    return {
                        ...item,
                        ctr: ctr,
                    } as ICampaignData;
                });
                this.filterForm.totalPages = data.pages;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => {
                this.loading = false;
                this.subLoading--;
                const table = this.$refs.table as Table;
                table.doLayout();
            })
    }

    private getCampaignResponse() {
        return this.$http.adserverAPI.post('GetCampaignReport', {
            since: this.date[0],
            until: this.date[1],
            status: this.filterForm.status,
            app: this.filterForm.apps.map((app: IAPP) => app.key),
            query: this.filterForm.query,
            page_no: this.filterForm.page,
            sort: this.filterForm.sort,
            page_size: this.filterForm.pageSize,
        })
    }

    private mounted() {
        this.$nextTick(() => {
            this.$http.adserverAPI.post('GetSSPAppList', {inventory: false}).then((res: any) => res.data)
                .then((data: IAPP[]) => {
                    this.appOptions = data.map((item: IAPP) => {
                            return {
                                label: item.name,
                                value: item,
                            } as SelectOptionType<IAPP>;
                        })
                            .sort((a: SelectOptionType<IAPP>, b: SelectOptionType<IAPP>) => a.label < b.label ? -1 : 1);
                })
            this.getCampaignResponseHandler();
        })
    }
}


